import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
    this.setState({ errorInfo });
  }
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-6 py-12">
          <p className="font-serif-display text-3xl text-[#0a2140]">Something went wrong.</p>
          <p className="text-sm text-stone-500 mt-2 max-w-md">
            The page hit an unexpected error. Reload to continue browsing Zaveri Trunk.
          </p>
          {this.state.error && (
            <div className="mt-4 p-4 bg-stone-100 border border-stone-300 rounded-xl text-left max-w-2xl text-xs font-mono text-stone-800 overflow-x-auto">
              <p className="font-bold text-red-600 mb-1">{this.state.error.toString()}</p>
              {this.state.errorInfo?.componentStack && (
                <pre className="text-[11px] text-stone-600 whitespace-pre-wrap leading-relaxed max-h-48 overflow-y-auto">
                  {this.state.errorInfo.componentStack}
                </pre>
              )}
            </div>
          )}
          <button onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            className="mt-6 bg-[#0a2140] text-white text-sm font-semibold rounded-full px-6 py-2.5 hover:brightness-110">
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
